import { API } from '@/api'

export const getAllBrandDetectionModels = () => API.get('/models/');
export const getModel = id => API.get(`/models/${id}/`);
export const getModelInProgress = () => API.get('/models/model-in-progress/');
export const getModelsHistory = () => API.get('/models/history/');
export const getRetrainAllowed = () => API.get('/models/retrain-allowed/');
export const retrainModel = params => API.post('/models/retrain/', params);
export const stopTrainingModel = (id, params) => API.post(`/models/${id}/stop-training/`, null, { params });
